import type { IIssueSummaryResponse } from '@kcftech/prometheustypescriptapiclient';
import type { IssueMetricType, Metric } from 'shared/issue_metrics/types';
import { formatSavings } from 'utils/activity';

export const VALUE_FORMATTER = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export function formatMetricValue(value: number | string, type: IssueMetricType): string {
    if (typeof value === 'string') {
        return value;
    }

    switch (type) {
        case 'savings':
            return `$${formatSavings(value.toString())}`;
        case 'days':
        case 'downtime':
        case 'new':
        case 'open':
        case 'severe':
            return VALUE_FORMATTER.format(value);
        default:
            return value.toString();
    }
}

export function formatMetrics(metrics: IIssueSummaryResponse): Metric[] {
    return [
        { label: 'NEW', subLabel: 'ISSUES', value: metrics.NewIssueCount, type: 'new' },
        {
            label: 'OPEN',
            subLabel: 'ISSUES',
            value: metrics.OpenIssueCount,
            type: 'open',
        },
        {
            label: 'SEVERE',
            subLabel: 'ISSUES',
            value: metrics.SevereIssueCount,
            type: 'severe',
        },
        {
            label: 'AVERAGE DAYS',
            subLabel: 'ISSUE OPEN',
            value: metrics.AverageDaysIssueOpened,
            type: 'days',
        },
        {
            label: 'DOWNTIME',
            subLabel: 'HOURS SAVED',
            value: metrics.DowntimeHoursSaved,
            type: 'downtime',
        },
        {
            label: 'TOTAL',
            subLabel: 'SAVINGS',
            value: metrics.TotalSavings,
            type: 'savings',
        },
    ];
}
